import * as React from "react";

import {
  VeteranAutoProductDetailsFormValues,
  VeteranAutoTexts,
} from "../veteranAutoInterface";

import { ProductBackendName } from "Components/Features/CheckPrice/Products/productTypes";
import InsuranceOwnerFormElements from "Components/Form/CommonFormElements/InsuranceOwnerFormElement";
import { RecentDamages } from "Components/Form/RecentDamages";
import { TextLanguage } from "Store/texts/interfaces";
import { FormikProps } from "formik";

interface Props {
  readonly formProps: FormikProps<VeteranAutoProductDetailsFormValues>;
  readonly texts: VeteranAutoTexts["formText"]["checkPrice"];
  readonly lang: TextLanguage;
}

export const FormElements = (props: Props): JSX.Element => {
  const { formProps, texts, lang } = props;

  return (
    <>
      <InsuranceOwnerFormElements
        formProps={formProps}
        formText={texts}
        lang={lang}
      />
      <RecentDamages
        formProps={formProps}
        productName={ProductBackendName.VETERAN_AUTO}
      />
    </>
  );
};
